type InspectTypeStatusKey =
  | "boolean"
  | "number"
  | "select"
  | "description"
  | "photo";

export const insepectTypeStatus = {
  boolean: "체크",
  number: "숫자",
  select: "선택",
  description: "설명",
  photo: "사진",
};

export const getInspectTypeStatus = (status: InspectTypeStatusKey) => {
  if (!status) return { status: "-", color: "gray.7" };

  let color: string;
  switch (status) {
    case "boolean":
      color = "blue.7";
      break;
    case "number":
      color = "green.7";
      break;
    case "select":
      color = "orange.7";
      break;
    case "description":
      color = "purple.7";
      break;
    case "photo":
      color = "teal.7";
      break;
    default:
      color = "";
      break;
  }

  return {
    status: insepectTypeStatus[status],
    color: color,
  };
};
